import classNames from 'classnames';
import { Tooltip } from 'antd';
import { useChatContext } from '@common/Chat/ChatContext';
import { useLessonChats } from '@/helpers/lessonChats';
import s from './index.module.css';

// Групповой чат подписывается только названием своей группы, общий — «Общий».
// Курс/тема/урок в панели урока избыточны: ученик и так внутри этого урока.
const getLessonChatTitle = (chat) => chat?.shortName || chat?.name || 'Чат урока';

const getTooltipContainer = (triggerNode) =>
  triggerNode.closest('[data-lesson-video-fullscreen="true"]') || document.body;

export const LessonChatsList = ({
  chats = [],
  onSelect,
  className = '',
  emptyText = 'Для этого урока нет доступных чатов',
  onLoadMore = null,
  compact = false,
}) => (
  <div className={classNames(s.list, { [s.compact]: compact }, className)}>
    {!chats.length && <div className={s.empty}>{emptyText}</div>}
    {chats.map(chat => {
      const chatButton = (
        <button
          key={chat.id}
          type="button"
          className={s.chatItem}
          aria-label={compact ? getLessonChatTitle(chat) : undefined}
          onClick={() => onSelect?.(chat.id)}
        >
          <span className={s.avatar}>Ч</span>
          <span className={s.chatItemContent}>
            <span className={s.chatItemTitle}>{getLessonChatTitle(chat)}</span>
          </span>
          {chat.unreadCount > 0 && <span className={s.unread}>{chat.unreadCount}</span>}
        </button>
      );

      return compact ? (
        <Tooltip
          key={chat.id}
          title={getLessonChatTitle(chat)}
          placement="left"
          getPopupContainer={getTooltipContainer}
        >
          {chatButton}
        </Tooltip>
      ) : (
        chatButton
      );
    })}
    {onLoadMore && (
      <button type="button" className={s.more} onClick={onLoadMore}>Показать ещё</button>
    )}
  </div>
);

/**
 * Панель «Чаты по уроку». Сам разговор открывается в обычном чате платформы:
 * у чата урока настоящий chat_id, отдельный интерфейс сообщений ему не нужен.
 */
export const LessonChatsSidebar = ({ lessonId }) => {
  const { chats } = useLessonChats(lessonId);
  const chatContext = useChatContext();

  return (
    <LessonChatsList
      chats={chats}
      onSelect={chatId => chatContext?.changePage(
        'inChat',
        chatId,
        'create',
        { selectedTab: 'lesson', lessonId },
      )}
    />
  );
};
